import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconSearchProps extends SVGProps<any> {}
export class SVGIconArrowDuplo extends Component<SVGIconSearchProps> {
  render() {
    const { width = 14, height = 13, color = '#11465D', ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-angle"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 14 13`}
        fill={color}
        {...rest}
      >
        <g>
          <path
            d="M0.573583 7.87036L5.75685 13L7.13965 11.6296L1.95638 6.5L7.13965 1.37036L5.75293 0L0.573583 5.12964C0.206136 5.49312 -0.000284672 5.98604 -0.000284672 6.5C-0.000284672 7.01396 0.206136 7.50688 0.573583 7.87036Z"
            fill={color}
          />
          <path
            d="M6.73715 7.18518L12.6172 13L14 11.6296L8.81673 6.5L14 1.37036L12.6133 0L6.73323 5.81482C6.55002 5.99707 6.44752 6.24382 6.44825 6.5008C6.44899 6.75778 6.5529 7.00395 6.73715 7.18518Z"
            fill={color}
          />
        </g>
      </SVG>
    );
  }
}
